/* formato.ts — ponto ÚNICO de import de formatação no front.
 *
 * As funções NÃO moram aqui: moram em @favo/core, que é o único lugar onde
 * texto vira número e número vira texto no produto inteiro. O servidor
 * formata com as mesmas funções, então relatório impresso e tela mostram
 * exatamente o mesmo dígito.
 *
 * Este arquivo existe só para dar um caminho estável de import
 * (`@/design/formato`) e para hospedar `formatarData`, a única que não pode
 * viver no core (depende do fuso do navegador).
 *
 * A máscara do campo de dinheiro NÃO está aqui: texto+cursor é comportamento
 * de controle, não formatação, e mora em `componentes/mascara-moeda.ts`.
 *
 * ATENÇÃO à unidade dos percentuais — é a armadilha mais cara deste domínio:
 *   formatarPercentual(0.12)       → "12,0%"   ← FRAÇÃO: tudo que sai do motor
 *   formatarPercentualPontos(12)   → "12,0%"   ← PONTOS: tudo que o usuário digita
 * Trocar uma pela outra erra por 100× num número plausível demais para alguém
 * desconfiar. Por isso os nomes são diferentes, e por isso `Valor` tem dois
 * formatos distintos em vez de um só chamado "percentual". */

export {
  parseNum,
  formatarMoeda,
  formatarMoedaDigitacao,
  formatarMoedaSemSimbolo,
  formatarMultiplicador,
  formatarNumero,
  formatarPercentual,
  formatarPercentualPontos,
  SEM_VALOR,
} from '@favo/core';

/** "12/08/2026" a partir de ISO. Depende do fuso do navegador: é do web. */
export function formatarData(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('pt-BR');
}
